import styled from 'styled-components';
import isUndefined from 'lodash/isUndefined';
const FlexBox = styled.div `
  ${({ theme, gap }) => gap && `gap: ${theme.spacing * gap}px;`}
  ${({ flexWrap }) => flexWrap && `flex-wrap: ${flexWrap};`}
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ alignItems = 'center' }) => `align-items: ${alignItems};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ width }) => width && `width: ${width};`}
  ${({ theme, m, mb, mt, ml, mr, my, mx }) => (!isUndefined(m) ||
    !isUndefined(mb) ||
    !isUndefined(mt) ||
    !isUndefined(ml) ||
    !isUndefined(mr) ||
    !isUndefined(my) ||
    !isUndefined(mx)) &&
    `margin: ${(mt || m || my || 0) * theme.spacing}px ${(mr || m || mx || 0) * theme.spacing}px ${(mb || m || my || 0) * theme.spacing}px ${(ml || m || mx || 0) * theme.spacing}px;`}
  ${({ theme, p, pb, pt, pl, pr }) => (!isUndefined(p) ||
    !isUndefined(pb) ||
    !isUndefined(pt) ||
    !isUndefined(pl) ||
    !isUndefined(pr)) &&
    `padding: ${(pt || p || 0) * theme.spacing}px ${(pr || p | 0) * theme.spacing}px ${(pb || p | 0) * theme.spacing}px ${(pl || p | 0) * theme.spacing}px;`}
  display: flex;
`;
export default FlexBox;
